/* ============================================
   SHOP ALL — Scroll Reveal
   ============================================ */

(function () {
  'use strict';

  var cards = document.querySelectorAll('.noxor-shop-card');
  if (!cards.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var card = entry.target;
          var delay = parseInt(card.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () {
            card.classList.add('revealed');
          }, delay);
          observer.unobserve(card);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  cards.forEach(function (card) {
    observer.observe(card);
  });
})();
